export const breadcrumbsDisplayNameMap = {
  'dme-customer-information': 'Patient info',
  'search-physician': 'Provider info',
  results: 'Select provider',
  checkout: 'Check out',
}
